import {
  Box,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Chip
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  createNumberFormatField,
  createTextField,
  Button,
  Paper
} from '@roc/ui';
import CloseIcon from '@material-ui/icons/Close';
import { Layout } from '@roc/feature-app-core';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useExternalAgentLoansStore } from 'libs/feature-title-agent/src/hooks/useExternalAgentLoansStore';
import { VendorBankInformationVerification } from './vendorBankInformation/vendorBankInformationVerification';

const enum Status {
  APPROVED = 'Approved',
  REQUESTED = 'Requested',
  PENDING_APPROVAL = 'Pending Approval',
  NOT_VERIFIED = 'Not Verified',
}

const useStyles = makeStyles(theme => ({
  dialogStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonStyle: {
    marginRight: '10px',
    height: '40px',
  },
  gridChip: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  approvedChip: {
    backgroundColor: '#49be25',
    letterSpacing: 2,
    color: '#000000',
    fontWeight: 'bold',
    marginLeft: '5px'
  },
  notRequestedChip: {
    backgroundColor: '#be2528',
    letterSpacing: 2,
    color: '#ffffff',
    fontWeight: 'bold',
    marginLeft: '5px'
  },
  newBankInfoDiv: {
    paddingTop: '60px',
  },
}));


export const CompanyBankInformation = observer(() => {
  const [openEditBankInfoModal, setEditBankInfoModal] = useState(false);
  const classes = useStyles();
  const { vendorCompanyProfileStore } = useExternalAgentLoansStore();
  const { companyInformation, profileBankInformationFormStore, vendorBankInformationStore } = vendorCompanyProfileStore;
  const status = companyInformation?.bankDetails?.bankInfoVerified;

  const getChipStatus = (status) => {
    return status ? classes.approvedChip : classes.notRequestedChip;
  }

  const handleEditBankInfoModal = () => {
    setEditBankInfoModal(true);
  };

  const handleCloseEditBankInfoModal = () => {
    vendorBankInformationStore.bankInformationFormStore.reset();
    setEditBankInfoModal(false);
    vendorBankInformationStore.moveToStep(0);
  };

  return (
    <>
      <Paper style={{ padding: '16px', marginTop: 16 }}>
        <Grid
          item
          style={{ padding: '16px', marginBottom: 16 }}
          container
          justifyContent="space-between"
        >
          <Grid item xs={6} className={classes.gridChip}>
            <Typography variant="h5">BANK INFORMATION</Typography>
            <Chip
              label={`${status ? 'VERIFIED' : 'NOT VERIFIED'}`}
              className={getChipStatus(status)}
            />
          </Grid>
          <Grid
            item
            xs={6}
            justifyContent="flex-end"
            style={{ display: 'flex' }}
          >
            <Button
              color="primary"
              variant="contained"
              onClick={handleEditBankInfoModal}
              testId="edit"
            >
              UPDATE BANK INFO
            </Button>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            {createTextField({
              store: profileBankInformationFormStore,
              testId: 'beneficiaryAccountName',
              fieldName: 'beneficiaryAccountName',
              label: 'Account Name',
              disabled: true,
            })}
          </Grid>
          <Grid item xs={6}>
            {createTextField({
              store: profileBankInformationFormStore,
              testId: 'beneficiaryBankName',
              fieldName: 'beneficiaryBankName',
              label: 'Bank Name',
              disabled: true,
            })}
          </Grid>
          <Grid item xs={6}>
            {createNumberFormatField({
              store: profileBankInformationFormStore,
              testId: 'beneficiaryRoutingNumber',
              fieldName: 'beneficiaryRoutingNumber',
              label: 'Routing Number',
              format: '#########',
              disabled: true,
            })}
          </Grid>
          <Grid item xs={6}>
            {createNumberFormatField({
              store: profileBankInformationFormStore,
              testId: 'beneficiaryAccountNumber',
              fieldName: 'beneficiaryAccountNumber',
              label: 'Account Number',
              disabled: true,
            })}
          </Grid>
        </Grid>
      </Paper>
      <Layout>
        <Dialog
          open={openEditBankInfoModal}
          onClose={handleCloseEditBankInfoModal}
          PaperProps={{
            style: {
              minWidth: '95%',
              maxWidth: '95%',
              minHeight: '95%',
              maxHeight: '95%',
            },
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleCloseEditBankInfoModal}
            style={{ position: 'absolute', right: 0, top: 0 }}
          >
            <CloseIcon />
          </IconButton>
          <VendorBankInformationVerification />
        </Dialog>
      </Layout>
    </>
  );
});
